export default __webpack_public_path__ + "66050df1b75f586566f03cf9e9a95eed.svg";